<article class="">
    <header class="">
        <div class="">
            <ul class="list-inline d-flex justify-content-between mb-0">
                <li class="list-inline-item">
                    <h1 class="">Ocean Rate Methodology</h1>
                </li>
                <li class="list-inline-item">
                    <button class="btn btn-icon btn-light-info mx-1" (click)="printPage()">
                        <i class="ti ti-printer"></i>
                    </button>
                    <button aria-label="Copy link" class="btn btn-icon btn-light-info" (click)="copyFullPageText()">
                        <i class="ti ti-copy"></i>
                    </button>
                </li>
            </ul>
        </div>
    </header>
    <div class="">
        <div class="article kb-article" data-testid="article-body" dir="auto">
            <p>All sea freight rates imported into the Xeneta platform are defined as the total ocean freight cost
                (port-to-port), and include:</p>
            <ul>
                <li class="f-18">Bunker Adjustment Factor (<strong>BAF</strong>)</li>
                <li class="f-18">Currency Adjustment Factor (<strong>CAF</strong>)</li>
                <li class="f-18">Emissions Trading System (<strong>ETS</strong>)</li>
            </ul>
            <blockquote class="my-4 p-3 bg-yellow-100 color-block">
                <p class="m-0"><strong>ETS</strong> surcharges are included in all rates valid from Jan 1, 2024.</p>
            </blockquote>
            <ul>
                <li>Canal surcharges</li>
                <li>All other relevant surcharges within Xeneta's port-to-port definition</li>
            </ul>
            <blockquote class="my-4 p-3 bg-gray-300 color-block">For a detailed overview of surcharges included in our
                rates, you can <a href="https://www.xeneta.com/hubfs/static/surcharge-list.pdf" target="_blank"
                    rel="noopener noreferrer">download the full list</a> in PDF format (194 Kb).</blockquote>
            <p>Terminal handling charges — at the origin (<strong>OTHC</strong>) and destination (<strong>DTHC</strong>)
                ports — are applied based on our THC methodology.</p>
            <blockquote class="my-4 p-3 bg-gray-300 color-block">
                <p>In addition to the surcharges included into the freight rates provided by Xeneta, we also offer a
                    separate detailed breakdown of <strong>Fuel</strong>, <strong>Congenstion</strong> and <strong>Peak
                        Season</strong> surcharges on the largest global trade lanes in our <a data-elevio-article="129"
                        href="https://help.xeneta.com/en/articles/129" target="_blank"><span
                            aria-label="Surcharges Data" data-elevio-article="129">Surcharges</span></a> add-on.</p>
            </blockquote>

            <h2>Container Types</h2>
            <p>Freight rate data in Xeneta is collected only for <strong>20' Dry</strong>, <strong>20' Reefer</strong>,
                <strong>20' Tank</strong>, <strong>40' Dry</strong>, <strong>40' HC</strong>, and <strong>40' Reefer
                    HC </strong> container types.
            </p>

            <p>Any data related to special container equipment such as <strong>Flat Rack</strong>,
                <strong>Platform</strong>, <strong>Tank</strong> or <strong>Open Top</strong> is excluded from our
                aggregation.
            </p>
        </div>
    </div>
</article>